
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drop-the-price",
      function () {
        return require("private-next-pages/drop-the-price/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drop-the-price"])
      });
    }
  